<main class="em-l-container main-content">
  <div *ngIf="loading">
    <app-loader></app-loader>
  </div>

  <div *ngIf="!loading" class="two-columns">
    <div class="left-container">
      <app-event-list [allEvents]="allEvents"></app-event-list>
    </div>
    <div class="right-container">
      <router-outlet></router-outlet>
    </div>
  </div>
</main>
